import { Component, HostBinding, Input } from '@angular/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-icon-button',
    template: `
        <ng-template #iconTemplate>
            <app-table-action-spinner *ngIf="spinner"></app-table-action-spinner>
            <ng-container *ngIf="!spinner">
                <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
                <mat-icon><ng-content></ng-content></mat-icon>
            </ng-container>
        </ng-template>
        <ng-container *ngIf="!placeholder; else placeholderTemplate">
            <span [title]="title" (click)="stopEvent($event)">
                <a *ngIf="href" mat-button class="icon-button" [href]="href" [class.disabled]="disabled" [target]="target">
                    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
                </a>
                <button *ngIf="!href" mat-button class="icon-button" [type]="buttonType" [disabled]="disabled">
                    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
                </button>
            </span>
        </ng-container>
        <ng-template #placeholderTemplate>
            <button mat-button class="icon-button" (click)="stopEvent($event)">
                <egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder>
            </button>
        </ng-template>
    `,
    styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent
{
    @Input() protected href?: string;
    @Input() protected target = '_blank';
    @Input() protected icon?: string;
    @Input() @HostBinding('class.remove') protected remove = false;
    @Input() protected buttonType: 'submit' | 'button' = 'submit';
    @Input() @HostBinding('class.more-icon-at-the-end') protected moreIconAtTheEnd = false;
    @Input() protected placeholder = false;
    @Input() protected spinner = false;
    @Input() protected title = '';
    @Input() protected disabled = false;
    @HostBinding('class.disabled') protected get disabledOrPlaceholder() { return this.disabled || this.placeholder; }
    @Input() protected disableMode: 'stopPropagation' | 'preventDefault' = 'stopPropagation';
    protected stopEvent(e: MouseEvent) { if (this.disabled) e[this.disableMode](); }
}
